/* Version: 3.5.149 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var arrowRight = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    width: "9px",
    height: "12px",
    focusable: "false",
    viewBox: "0 0 9 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/jsx("g", {
        transform: "translate(-1160.000000, -377.000000)",
        fill: "#C2C3C9",
        fillRule: "nonzero",
        children: /*#__PURE__*/jsx("path", {
          d: "M1163.99019,378.656854 L1166.65685,378.656854 L1166.65685,386.656854 L1163.99019,386.656854 L1163.99019,381.323521 L1158.65685,381.323521 L1158.65685,378.656854 L1163.99019,378.656854 Z",
          transform: "translate(1162.656854, 382.656854) rotate(-315.000000) translate(-1162.656854, -382.656854) "
        })
      })
    })]
  });
});

export { arrowRight as default };
